import { FieldDisplayType } from "@/pages/settings/components/dealsSettings/FieldManagement/types";

export type FieldType = FieldDisplayType | string;

export const FIELD_CLASSNAME =
  "border-[0.5px] border-border-field-default transition-all duration-200 ease-in-out rounded-lg hover:border-border-field-hover shadow-field";
export const FOCUS_CLASSNAME =
  "!border-border-field-focus bg-surface-focus-selected shadow-inner";
export const HALF_WRAPPER_CLASSNAME = "w-[23rem]";
export const DATE_FIELD_BADGE_CLASSNAME =
  "border border-border-border3 bg-badges-default transition-all duration-200 ease-in-out rounded-md hover:border-border-field-hover";

export interface ResponseType {
  value?: any;
  type?: string | null;
  setValueType?: any;
  unit?: string | null;
  options?: any[];
  minValue?: string | number;
  maxValue?: string | number;
  option1?: string;
  option2?: string;
  checkboxInlineText?: string;
  placeholder?: string;
  supportedFiles?: string;
  allowMultipleFiles?: boolean;
}

export const getPlaceholder = (
  fieldType: FieldType,
  t: (key: string) => string
): string => {
  switch (fieldType) {
    case FieldDisplayType.NUMBER:
      return t("questionnaire.placeholders.enterNumber");
    case FieldDisplayType.PERCENTAGE:
      return t("questionnaire.placeholders.enterPercentage");
    case FieldDisplayType.CURRENCY:
      return t("questionnaire.placeholders.enterAmount");
    case FieldDisplayType.EMAIL:
      return t("questionnaire.placeholders.enterEmail");
    case FieldDisplayType.URL:
      return t("questionnaire.placeholders.enterUrl");
    case FieldDisplayType.TEXTAREA:
      return t("questionnaire.placeholders.enterText");
    case FieldDisplayType.DATE:
      return t("questionnaire.placeholders.selectDate");
    case FieldDisplayType.PHONE:
      return t("questionnaire.placeholders.enterPhone");
    default:
      return t("questionnaire.placeholders.enterValue");
  }
};

export const processValue = (
  value: string,
  fieldType: FieldType,
  responseType?: ResponseType
): string => {
  if (fieldType === FieldDisplayType.NUMBER) {
    const numValue = Number(value);
    if (!isNaN(numValue)) {
      const minValue = responseType?.minValue
        ? Number(responseType.minValue)
        : undefined;
      const maxValue = responseType?.maxValue
        ? Number(responseType.maxValue)
        : undefined;

      if (minValue !== undefined && numValue < minValue) {
        return minValue.toString();
      } else if (maxValue !== undefined && numValue > maxValue) {
        return maxValue.toString();
      }
    }
  }
  return value;
};

export const createSwitchOptions = (
  responseType?: ResponseType,
  t?: (key: string) => string
) => {
  return {
    option1:
      responseType?.option1 ||
      (t ? t("questionnaire.options.option1") : "Option 1"),
    option2:
      responseType?.option2 ||
      (t ? t("questionnaire.options.option2") : "Option 2")
  };
};
